/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createSavingsTransfer} from '../api'

export const useMutationCreateSavingsTransfer = createReactQueryMutationHook('createSavingsTransfer', createSavingsTransfer)
